import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { Card, TextField, Button } from "@mui/material";
import { Users, Gift, Presentation } from "lucide-react";
import { toast } from "react-hot-toast";

export default function StatsCollectionForm() {
  const [stats, setStats] = useState([
    {
      icon: Gift,
      value: "",
      label: "Gifts",
      suffix: "+",
      description:
        "The word gift or a present is an item given to someone without the expectation of payment or anything in return.",
    },
    {
      icon: Presentation,
      value: "",
      label: "Projects",
      suffix: "+",
      description:
        "A project is an activity to meet the creation of a unique product or service, and thus activities that are undertaken to accomplish routine activities cannot be considered projects.",
    },
    {
      icon: Users,
      value: "",
      label: "Clients",
      suffix: "+",
      description:
        "The word client can also mean customer according to most dictionaries, but it has a separate definition as someone who receives professional services.",
    },
  ]);

  const fetchCurrentStats = async () => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/fetchstats";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        const data = await response.json();

        setStats((prevStats) =>
          prevStats.map((stat) => ({
            ...stat,
            value: data[stat.label] || 0,
          }))
        );
      } else {
        console.error("Failed to fetch stats:", response.status);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const insertstats = async () => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/createtest";

    const formattedStats = stats.reduce((acc, stat) => {
      acc[stat.label] = stat.value;
      return acc;
    }, {});

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sessionStorage.getItem("accesstoken")}`,
      },
      body: JSON.stringify({
        role: sessionStorage.getItem("role"),
        Clients: formattedStats.Clients,
        Gifts: formattedStats.Gifts,
        Projects: formattedStats.Projects,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      toast.success("Stats Updated Successfully");
      console.log(data);
    } else {
      toast.error("Error updating stats ");
    }
  };

  useEffect(() => {
    fetchCurrentStats();
  }, []);

  const handleChange = (index, event) => {
    const newStats = [...stats];
    newStats[index].value = event.target.value;
    setStats(newStats);
  };

  return (
    <div className="py-10">
      <div className="container px-4 mx-auto">
        <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-3">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
            >
              <Card className="p-8 h-full  !transition-transform !duration-300">
                <div className="flex items-center space-x-10">
                  <div className="flex items-center justify-center text-[#151C62] mb-4">
                    <stat.icon size={40} />
                  </div>
                  <TextField
                    label={stat.label}
                    type="number"
                    inputProps={{ min: 0 }}
                    variant="outlined"
                    value={stat.value}
                    onChange={(e) => handleChange(index, e)}
                    fullWidth
                  />
                </div>
                <p className="mt-3 text-base text-gray-500 leading-relaxed">
                  {stat.description}
                </p>
              </Card>
            </motion.div>
          ))}
        </div>
        <div className="mt-6 flex justify-end">
          <Button variant="contained" color="primary" onClick={insertstats}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
